module.exports = __webpack_public_path__ + "img/0Q3A5468_L_Wood.e486d986.jpg";